// SWR Keys
// These keys identify cached data for SWR and are used to trigger revalidation.
// Keys can be used as-is or modified with suffixes or prefixes to represent
// paginated data, filtered views, or other variations.
// For example, "upcoming-orders-key-page-index-0" represents page 0 of upcoming orders.
export var SWR_KEYS;
(function (SWR_KEYS) {
    SWR_KEYS["SKIP_DAYS"] = "skip-days-key";
    SWR_KEYS["UPCOMING_ORDERS"] = "upcoming-orders-key";
    SWR_KEYS["ORDERS_BY_DATE"] = "orders-by-date-key";
    SWR_KEYS["CUSTOMER_ORDERS"] = "customer-orders-key";
    SWR_KEYS["COMPANY_PROVIDER"] = "company-provider-key";
})(SWR_KEYS || (SWR_KEYS = {}));
